export default __webpack_public_path__ + "static/media/carousel_right_arrow.f9acf77c.svg";